function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { twMerge } from "@stereoagency/tailwind-config";
import React, { forwardRef, useId } from "react";
import { useFormFieldStyle } from "../../hooks";
function $FormInput(_param, ref) {
    var id = _param.id, label = _param.label, required = _param.required, _param_inputClasses = _param.inputClasses, inputClasses = _param_inputClasses === void 0 ? "" : _param_inputClasses, _param_iconClasses = _param.iconClasses, iconClasses = _param_iconClasses === void 0 ? "" : _param_iconClasses, suffix = _param.suffix, error = _param.error, _param_state = _param.state, state = _param_state === void 0 ? "default" : _param_state, className = _param.className, props = _object_without_properties(_param, [
        "id",
        "label",
        "required",
        "inputClasses",
        "iconClasses",
        "suffix",
        "error",
        "state",
        "className"
    ]);
    var uniqid = useId();
    var styles = useFormFieldStyle({
        state: state
    });
    return /*#__PURE__*/ React.createElement("label", {
        htmlFor: id !== null && id !== void 0 ? id : uniqid,
        className: twMerge(styles.root, className, suffix ? "relative" : "")
    }, /*#__PURE__*/ React.createElement("input", _object_spread({
        ref: ref,
        id: id !== null && id !== void 0 ? id : uniqid,
        required: required,
        className: twMerge(styles.input, inputClasses)
    }, props)), /*#__PURE__*/ React.createElement("span", {
        className: styles.label
    }, label, required ? " *" : null), !!suffix && /*#__PURE__*/ React.createElement("div", {
        className: twMerge("absolute -top-2 right-6 pl-5 h-full flex items-center font-semibold font-heading opacity-50", iconClasses)
    }, suffix), !!error && /*#__PURE__*/ React.createElement("span", {
        className: styles.error
    }, error));
}
var FormInput = /*#__PURE__*/ forwardRef($FormInput);
export default FormInput;

//# sourceMappingURL=FormInput.js.map